import { useOverlays } from "contexts/OverlayContext";
import { useFinancialDocument } from "@api/financialDocument.api";
import { FinancialDocumentDrawerContent } from "./FinancialDocumentDrawerContent";

export const FinancialDocumentDrawer = () => {
    const { getOverlayInfo, overlayIsClosing } = useOverlays();
    const overlayInfo = getOverlayInfo("financialDocumentId");

    const { data: financialDocument } = useFinancialDocument(overlayInfo?.data);

    if (!overlayInfo?.data || !financialDocument) {
        return null;
    }

    return (
        <FinancialDocumentDrawerContent
            open={!overlayIsClosing}
            financialDocument={financialDocument}
        />
    );
};
